import Vue from 'vue';
import i18n from '@/plugins/i18n';
export default {
    initApp() {
        const locale = Vue.localStorage.get('language');
        if(locale && locale != i18n.locale) {
            i18n.locale = locale;
        }
    }
}